// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collections-structure-structure-item-select {
  display: flex;
  flex-direction: column;
  height: 400px;
  overflow-y: auto;
  transition: opacity 0.2s;
}
.dl-collections-structure-structure-item-select_denied-and-empty {
  height: 450px;
}
.dl-collections-structure-structure-item-select_disabled {
  opacity: 0.7;
  pointer-events: none;
}
.dl-collections-structure-structure-item-select__breadcrumbs {
  margin-bottom: 12px;
}
.dl-collections-structure-structure-item-select__items {
  height: 100%;
  overflow-y: auto;
}
.dl-collections-structure-structure-item-select__denied-message-wrapper {
  margin-bottom: 8px;
}
.dl-collections-structure-structure-item-select__denied-message {
  display: flex;
  align-items: center;
  padding: 12px;
}
.dl-collections-structure-structure-item-select__denied-message-icon {
  height: 15px;
  margin-right: 10px;
}
.dl-collections-structure-structure-item-select__denied-message-text {
  font-size: 13px;
  line-height: 18px;
}
.dl-collections-structure-structure-item-select__main-loader {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.dl-collections-structure-structure-item-select__page-loader {
  display: flex;
  align-self: center;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CollectionStructureDialog/StructureItemSelect/StructureItemSelect.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,YAAA;EACA,oBAAA;AAAR;AAGI;EACI,mBAAA;AADR;AAII;EACI,YAAA;EACA,gBAAA;AAFR;AAKI;EACI,kBAAA;AAHR;AAMI;EACI,aAAA;EACA,mBAAA;EACA,aAAA;AAJR;AAOI;EACI,YAAA;EACA,kBAAA;AALR;AAQI;EACI,eAAA;EACA,iBAAA;AANR;AASI;EACI,aAAA;EACA,OAAA;EACA,sBAAA;AAPR;AAUI;EACI,aAAA;EACA,kBAAA;EACA,aAAA;AARR","sourcesContent":[".dl-collections-structure-structure-item-select {\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n  overflow-y: auto;\n  transition: opacity 0.2s;\n}\n.dl-collections-structure-structure-item-select_denied-and-empty {\n  height: 450px;\n}\n.dl-collections-structure-structure-item-select_disabled {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.dl-collections-structure-structure-item-select__breadcrumbs {\n  margin-bottom: 12px;\n}\n.dl-collections-structure-structure-item-select__items {\n  height: 100%;\n  overflow-y: auto;\n}\n.dl-collections-structure-structure-item-select__denied-message-wrapper {\n  margin-bottom: 8px;\n}\n.dl-collections-structure-structure-item-select__denied-message {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n}\n.dl-collections-structure-structure-item-select__denied-message-icon {\n  height: 15px;\n  margin-right: 10px;\n}\n.dl-collections-structure-structure-item-select__denied-message-text {\n  font-size: 13px;\n  line-height: 18px;\n}\n.dl-collections-structure-structure-item-select__main-loader {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.dl-collections-structure-structure-item-select__page-loader {\n  display: flex;\n  align-self: center;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
